import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const steps = [{
  number: 1,
  title: 'Prospectare',
  description: 'Contactarea proprietarilor din liste și identificarea oportunităților'
}, {
  number: 2,
  title: 'Calificare',
  description: 'Evaluarea proprietății și a condițiilor de colaborare cu proprietarul'
}, {
  number: 3,
  title: 'Contract',
  description: 'Semnarea contractului de colaborare cu proprietarul'
}, {
  number: 4,
  title: 'Promovare / Matching',
  description: 'Lansarea campaniilor de promovare și potrivirea cu clienții potriviți'
}, {
  number: 5,
  title: 'Vizionare',
  description: 'Organizarea și desfășurarea vizionărilor cu clienții'
}, {
  number: 6,
  title: 'Ofertare / Negociere',
  description: 'Primirea ofertelor și negocierea condițiilor optime'
}, {
  number: 7,
  title: 'Verificări & Dosar',
  description: 'Verificarea actelor și pregătirea dosarului complet'
}, {
  number: 8,
  title: 'Semnare',
  description: 'Organizarea semnării contractului final'
}, {
  number: 9,
  title: 'Facturare / Arhivare',
  description: 'Emiterea facturilor și arhivarea tranzacției în sistem'
}];
export function TimelineProcess() {
  const [expandedStep, setExpandedStep] = useState<number | null>(null);
  return <div className="space-y-4" data-id="element-6815">
      {steps.map((step, index) => <motion.div key={step.number} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.4,
      delay: index * 0.1
    }} data-id="element-6816">
          <button onClick={() => setExpandedStep(expandedStep === step.number ? null : step.number)} className="w-full bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all text-left border-2 border-transparent hover:border-[#357BEB]" data-id="element-6817">
            <div className="flex items-center justify-between" data-id="element-6818">
              <div className="flex items-center space-x-4" data-id="element-6819">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#357BEB] to-[#132C53] flex items-center justify-center text-white font-bold shadow-lg" data-id="element-6820">
                  {step.number}
                </div>
                <div data-id="element-6821">
                  <h3 className="text-lg font-bold text-[#132C53]" data-id="element-6822">
                    {step.title}
                  </h3>
                </div>
              </div>
              <motion.div animate={{
            rotate: expandedStep === step.number ? 180 : 0
          }} transition={{
            duration: 0.3
          }} data-id="element-6823">
                <ChevronDownIcon className="w-6 h-6 text-[#357BEB]" data-id="element-6824" />
              </motion.div>
            </div>
            <AnimatePresence data-id="element-6825">
              {expandedStep === step.number && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-6826">
                  <p className="text-gray-600 mt-4 pl-16" data-id="element-6827">{step.description}</p>
                </motion.div>}
            </AnimatePresence>
          </button>
        </motion.div>)}
    </div>;
}